// removed by extract-text-webpack-plugin
module.exports = {"app":"src-pages----privacy-module---app---1kt3V","pageContainer":"src-pages----privacy-module---pageContainer---1qgS8","postBody":"src-pages----privacy-module---postBody----Spc-","header":"src-pages----privacy-module---header---ATfPM","appIcon":"src-pages----privacy-module---appIcon---315sr"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/privacy.module.scss
// module id = 176
// module chunks = 915738553496